module.exports = __webpack_public_path__ + "static/media/user-icon.d7a45623.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/user-icon.svg
// module id = 72
// module chunks = 0